import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }

import { ref, defineAsyncComponent } from 'vue'
import { VueDraggableNext } from 'vue-draggable-next'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexDraggable',
  setup(__props) {

const draggable = VueDraggableNext
const DraggableCard = defineAsyncComponent(() => import("@/components/theme/advance/draggable/DraggableCard.vue"))
const FooterCard = defineAsyncComponent(() => import("@/components/common/FooterCard.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(draggable), { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(DraggableCard)),
        _createVNode(_unref(FooterCard))
      ]),
      _: 1
    })
  ]))
}
}

})